// extracted by mini-css-extract-plugin
export default {"shopContainer":"Shop_shopContainer__Hy8h4","shopHeaderImg":"Shop_shopHeaderImg__DUJsG","shopItemsContainer":"Shop_shopItemsContainer__8zmtb"};